import { GetterTree } from 'vuex';
import { IdealProfileState, RootState } from './ideal-profile-types';

export const getters: GetterTree<IdealProfileState, RootState> = {
  skillsIdealProfile: (state) => state.idealProfile?.body,
  // skillsEmployeeProfile(state): string {
  //   const { user } = state;
  //   console.log('email', user);
  //   console.log('state', state);
  //   const email = (user && user.email) || 'saifi.razique@nile';
  //   console.log('email2', email);
  //   // const firstName = (user && user.firstName) || '';
  //   // const lastName = (user && user.lastName) || '';
  //   // return `${firstName} ${lastName}`;
  //   return email;
  // },
};
